export const BUAN_AUTHORIZED_STAFF: string[] = [
  // Add individual staff addresses here if needed.
  '0x0c1532000a30C0Ad1AA279FFDcD3A0792E10ccD0',
  '0x48ea61df42A9D86FCF4763F3f6369E99853F1812',
];
